const privateRoutes = [
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () => import('@/views/admin/Dashboard.vue'),
		meta: { requiresAuth: true, layout: 'vertical' },
	},
	{
		path: '/companies',
		component: () => import('@/views/admin/companies/CompaniesRoot.vue'),
		meta: { requiresAuth: true, layout: 'vertical' },
		children: [
			{
				path: '',
				name: 'Empresas',
				component: () => import('@/views/admin/companies/Companies.vue'),
			},
			{
				path: 'create',
				name: 'Nova Empresa',
				component: () => import('@/views/admin/companies/Create.vue'),
			},
			{
				path: 'edit/:id',
				name: 'Editar Empresa',
				component: () => import('@/views/admin/companies/Create.vue'),
			},
		],
	},
	{
		path: '/categories',
		component: () => import('@/views/admin/categories/CategoriesRoot.vue'),
		meta: { requiresAuth: true, layout: 'vertical' },
		children: [
			{
				path: '',
				name: 'Categorias',
				component: () => import('@/views/admin/categories/Categories.vue'),
			},
			{
				path: 'create',
				name: 'Nova Categoria',
				component: () => import('@/views/admin/categories/Create.vue'),
			},
			{
				path: 'edit/:id',
				name: 'Editar Categoria',
				component: () => import('@/views/admin/categories/Create.vue'),
			},
		],
	},
	{
		path: '/customers',
		name: 'Clientes',
		component: () => import('@/views/admin/customers/Customers.vue'),
		meta: { requiresAuth: true, layout: 'vertical' },
	},
]

export default privateRoutes
